import { render, staticRenderFns } from "./c_news_roll.vue?vue&type=template&id=30b68547&scoped=true"
import script from "./c_news_roll.vue?vue&type=script&lang=js"
export * from "./c_news_roll.vue?vue&type=script&lang=js"
import style0 from "./c_news_roll.vue?vue&type=style&index=0&id=30b68547&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b68547",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b68547')) {
      api.createRecord('30b68547', component.options)
    } else {
      api.reload('30b68547', component.options)
    }
    module.hot.accept("./c_news_roll.vue?vue&type=template&id=30b68547&scoped=true", function () {
      api.rerender('30b68547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_news_roll.vue"
export default component.exports